module.exports = __webpack_public_path__ + "static/media/adult-business-businessman-1061588.70313051.jpg";